import * as __mod_react from "react";
import * as __mod_react_dom from "react-dom";
import * as __mod_jsx from "react/jsx-runtime";
import * as __mod_rrd from "react-router-dom";
var require = (m) => {
  var __mods = {
    "react": __mod_react,
    "react-dom": __mod_react_dom,
    "react/jsx-runtime": __mod_jsx,
    "react-router-dom": __mod_rrd,
  };
  if (__mods[m]) return __mods[m];
  throw new Error("Cannot require " + m);
};
import{jsx as m}from"react/jsx-runtime";var n="https://cdn.magicpatterns.com/uploads/jx576Uvrsdy2amZz6VWU5V/Main_Logo_-_Color.png";function e({size:o=192,alt:t="Taama",className:a=""}){let r=typeof o=="number"?`${o}px`:o;return m("img",{src:n,alt:t,className:`block h-auto max-w-full object-contain ${a}`,style:{width:r},"data-id":"element-50","data-mp":"1vh8zqnaymncm"})}export{e as Logo};
//# sourceMappingURL=library.js.map
